import { useAppSelector } from '@/app/hooks';
import { AppState } from '@/app/store';
import {
  ILocale,
  ProductFilterState,
  setFormInUrl,
} from '@/components/Form/ProductsFilter/productsFilterSlice';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useSWR, { unstable_serialize } from 'swr';
import { getProductsByForm } from '@/lib/utilities/repository';
import useCategories from './useCategories';
import useIndustryCategories from './useIndustryCategories';

export default function useProducts() {
  const productFilter = useAppSelector(
    (state: AppState) => state.productFilter
  );
  const category_slug = useNativeCategorySlug();
  const industry_category_slug = useNativeIndustryCategorySlug();
  const { locale } = useRouter();

  useEffect(() => {
    console.log('updating url');
    setFormInUrl(productFilter);
  }, [productFilter]);

  const cacheKey = getUseProductCacheKey(
    productFilter,
    locale,
    category_slug,
    industry_category_slug
  );

  const { data, error } = useSWR(
    cacheKey,
    (_cacheKey) =>
      getProductsByForm({
        ...productFilter,
        selectedCategory: category_slug
          ? [category_slug.toString()]
          : undefined,
        selectedIndustryCategory: industry_category_slug
          ? [industry_category_slug]
          : undefined,
        locale: (locale ?? 'en-US') as ILocale,
      }),
    {
      revalidateOnFocus: false,
      revalidateOnMount: false,
    }
  );

  return {
    productsResponse: data,
    isLoading: !error && !data,
    isError: error,
  };
}
export function useNativeCategorySlug() {
  const { categories: categoriesOptions } = useCategories();
  const router = useRouter();
  const { category_slug } = router.query;
  function getNativeSlug(slugInUnknownLanguage: string) {
    const category = categoriesOptions.find(
      (c) => c.en_slug === slugInUnknownLanguage
    );
    return category ? category.slug : (slugInUnknownLanguage as string);
  }
  return getNativeSlug(category_slug?.toString() || '');
}
export function useNativeIndustryCategorySlug() {
  const { industryCategories: industryCategoriesOptions } =
    useIndustryCategories();
  const router = useRouter();
  const { industry_category_slug } = router.query;
  function getNativeSlug(slugInUnknownLanguage: string) {
    const industryCategory = industryCategoriesOptions.find(
      (c) =>
        c.slug == slugInUnknownLanguage || c.en_slug === slugInUnknownLanguage
    );
    return industryCategory
      ? industryCategory.slug
      : (slugInUnknownLanguage as string);
  }
  return getNativeSlug(industry_category_slug?.toString() || '');
}

export function getUseProductCacheKey(
  productFilter: ProductFilterState,
  locale?: string,
  category_slug?: string,
  industry_category_slug?: string
) {
  const key = unstable_serialize([
    category_slug ?? '',
    industry_category_slug ?? '',
    productFilter.countries,
    locale,
    productFilter.manufacturers,
    productFilter.maxPrice,
    productFilter.minPrice,
    productFilter.minYear,
    productFilter.maxYear,
    productFilter.order,
    productFilter.order_by,
    productFilter.page,
    productFilter.search,
  ]);
  return key;
}
